
























































import { Component, Vue, Prop } from "vue-property-decorator";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.min.css";

@Component({
  components: {}
})
export default class CreateAccountModalForm extends Vue {
  @Prop(Array) filtersWord!: any;
  @Prop(Object) filterFields!: any;
  @Prop(Function) removeFilterItem!: any;
  form = {
    email: "",
    name: "",
    food: null,
    checked: true
  };

  showModal() {
    (this as any).$refs["create-account"].show();
  }

  hideModal() {
    (this as any).$refs["create-account"].hide();
  }

  async onSubmit() {
    let payload: any = {};
    payload["is_part_time"] = (this as any).filterFields.is_part_time
      ? (this as any).filterFields.is_part_time
      : 0;
    payload["is_full_time"] = (this as any).filterFields.is_full_time
      ? (this as any).filterFields.is_full_time
      : 0;
    payload["is_remote"] = (this as any).filterFields.is_remote
      ? (this as any).filterFields.is_remote
      : 0;
    payload["is_temporal"] = (this as any).filterFields.is_temporal
      ? (this as any).filterFields.is_temporal
      : 0;
    payload["place_lat"] = (this as any).filterFields.place_lat
      ? (this as any).filterFields.place_lat
      : 0;
    payload["place_lng"] = (this as any).filterFields.place_lng
      ? (this as any).filterFields.place_lng
      : 0;
    payload["countryId"] = null;
    payload["provinceId"] = null;
    payload["cityId"] = (this as any).filterFields.location
      ? (this as any).filterFields.location.value
      : null;
    payload["lowest_expected_salary"] = (this as any).filterFields
      .lowest_expected_salary
      ? (this as any).filterFields.lowest_expected_salary
      : 0;
    payload["highest_expected_salary"] = (this as any).filterFields
      .highest_expected_salary
      ? (this as any).filterFields.highest_expected_salary
      : 0;
    payload["areaId"] = (this as any).filterFields.area
      ? (this as any).filterFields.area.value
      : null;

    let experiences = (this as any).filterFields.experiences.map((item: any) => {
      return item.value;
    });

    if (experiences.length > 0) {
      payload["experience"] = '["'.concat(experiences.toString()).concat('"]');
    }

    await (this as any).$root._post("alert", payload);

    (this as any).hideModal();
    Swal.fire("Alerta creada!", "Se creo la alerta correctamente.", "success");
  }
}
